"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AudioManager_1 = require("../../AudioManager");
var GameConstants_1 = require("../../GameConstants");
var GameVars_1 = require("../../GameVars");
var BoardManager_1 = require("../BoardManager");
var BoardState_1 = require("../BoardState");
var Pile_1 = require("./Pile");
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card(game, x, y, cardValue) {
        var _this = _super.call(this, game, x, y, "texture_atlas_2", Card.CARD_BACK) || this;
        Card.CARD_BACK = !_this.disableBranding() ? "card-back.png" : "card-back-1.png";
        _this.frameName = Card.CARD_BACK;
        _this.textureName = cardValue.suit + "-" + cardValue.value + ".png";
        _this.cardValue = cardValue;
        _this.pile = null;
        _this.dragging = false;
        _this.turned = false;
        _this.dealPile = true;
        _this.attachedCards = [];
        _this.inputEnabled = true;
        _this.timeLatestTap = 0;
        _this.scale.y = GameVars_1.GameVars.scaleY;
        _this.downX = 0;
        _this.downY = 0;
        _this.anchor.set(.5);
        _this.onAnimation = false;
        _this.onRebound = false;
        _this.events.onInputDown.add(_this.onDown, _this);
        _this.events.onInputUp.add(_this.onUp, _this);
        _this.events.onDragStart.add(_this.onDragStart, _this);
        _this.game.physics.enable(_this, Phaser.Physics.ARCADE, GameConstants_1.GameConstants.SHOW_BOUNDING_AREAS);
        return _this;
    }
    Card.prototype.disableBranding = function () {
        return gamezop.disableBranding();
    };
    Card.prototype.update = function () {
        _super.prototype.update.call(this);
        if (this.dragging || Card.tweening) {
            this.moveAttachedCards();
            if (this.game.input.activePointer.y < 100) {
                this.onUp();
            }
        }
        if (this.onAnimation) {
            if (this.y + this.height / 2 >= GameConstants_1.GameConstants.GAME_HEIGHT && !this.onRebound) {
                this.onRebound = true;
                this.rebound();
            }
        }
    };
    Card.prototype.movePos = function (x, y) {
        var d = Math.sqrt((this.x - x) * (this.x - x) + (this.y - y) * (this.y - y));
        var tweenTime = d / Card.CARD_SPEED;
        if (tweenTime === 0) {
            tweenTime = 20;
        }
        this.game.add.tween(this)
            .to({ x: x, y: y }, tweenTime, Phaser.Easing.Cubic.Out, true);
    };
    Card.prototype.flip = function () {
        this.turned = true;
        this.game.add.tween(this.scale)
            .to({ x: 0 }, 50, Phaser.Easing.Linear.None, true)
            .onComplete.add(function () {
            this.frameName = this.textureName;
            this.game.add.tween(this.scale)
                .to({ x: 1 }, 50, Phaser.Easing.Linear.None, true);
        }, this);
        AudioManager_1.AudioManager.getInstance().playSound("card_flip");
    };
    Card.prototype.flip2 = function () {
        this.turned = true;
        this.frameName = this.textureName;
    };
    Card.prototype.unflip2 = function () {
        this.turned = false;
        this.frameName = Card.CARD_BACK;
    };
    Card.prototype.unflip = function () {
        this.turned = false;
        this.game.add.tween(this.scale)
            .to({ x: 0 }, 50, Phaser.Easing.Linear.None, true)
            .onComplete.add(function () {
            this.frameName = Card.CARD_BACK;
            this.game.add.tween(this.scale)
                .to({ x: 1 }, 50, Phaser.Easing.Linear.None, true);
        }, this);
        AudioManager_1.AudioManager.getInstance().playSound("card_flip");
    };
    Card.prototype.move = function (flip, pile) {
        var y;
        this.dealPile = false;
        this.pile = pile;
        y = this.pile.y;
        if (flip) {
            this.turned = true;
        }
        if (!this.pile.foundation) {
            for (var i = 0; i < this.pile.piledCards.length; i++) {
                if (this.pile.piledCards[i].turned) {
                    y += Pile_1.Pile.CARDS_OFFSET;
                }
                else {
                    y += Pile_1.Pile.CARDS_OFFSET / 2;
                }
            }
        }
        pile.piledCards.push(this);
        this.x = this.pile.x;
        this.y = y;
        this.bringToTop();
        if (flip) {
            this.flip2();
        }
        else {
            this.unflip2();
        }
    };
    Card.prototype.firstMove = function (flip, count, pile) {
        var y;
        this.dealPile = false;
        this.pile = pile;
        y = this.pile.y;
        if (flip) {
            this.turned = true;
        }
        if (!this.pile.foundation) {
            for (var i = 0; i < this.pile.piledCards.length; i++) {
                if (this.pile.piledCards[i].turned) {
                    y += Pile_1.Pile.CARDS_OFFSET;
                }
                else {
                    y += Pile_1.Pile.CARDS_OFFSET / 2;
                }
            }
        }
        pile.addCard(this);
        var d = Math.sqrt((this.x - this.pile.x) * (this.x - this.pile.x) + (this.y - y) * (this.y - y));
        var tweenTime = d / Card.CARD_SPEED;
        var tween = this.game.add.tween(this)
            .to({ x: this.pile.x, y: y }, tweenTime, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function () {
            var rand = Math.floor(Math.random() * 3) + 1;
            AudioManager_1.AudioManager.getInstance().playSound("card_" + rand);
        }, this);
        this.bringToTop();
        if (flip) {
            this.flip();
        }
    };
    Card.prototype.release = function (rulesOk, pile) {
        var x;
        var y;
        Card.tweening = true;
        var noAudio = false;
        if ((pile || this.pile) && rulesOk) {
            if (this.pile) {
                if (this.pile.piledCards.length !== 0) {
                    if (!this.pile.piledCards[this.pile.piledCards.length - 1].turned) {
                        this.pile.piledCards[this.pile.piledCards.length - 1].flip();
                    }
                }
            }
            else if (this.dealPile) {
                BoardManager_1.BoardManager.currentInstance.deleteCardDealPile(this);
            }
            var pileAux = this.pile;
            if (this.pile === pile) {
                this.noMoveAnimation(20);
                noAudio = true;
            }
            this.pile = pile || this.pile;
            x = this.pile.x;
            y = this.pile.y;
            if (!this.pile.foundation) {
                for (var i = 0; i < this.pile.piledCards.length; i++) {
                    var num = BoardManager_1.BoardManager.currentInstance.compressPositions(this.pile);
                    if (num > 0) {
                        if (this.pile.piledCards[i].turned) {
                            y += Pile_1.Pile.CARDS_OFFSET / (1 + (num * .1));
                        }
                        else {
                            y += Pile_1.Pile.CARDS_OFFSET / 2;
                        }
                    }
                    else {
                        if (this.pile.piledCards[i].turned) {
                            y += Pile_1.Pile.CARDS_OFFSET;
                        }
                        else {
                            y += Pile_1.Pile.CARDS_OFFSET / 2;
                        }
                    }
                }
            }
        }
        else {
            // por si no estaba asociada a ninguna pila
            x = this.prevX;
            y = this.prevY;
            this.noMoveAnimation(10);
            noAudio = true;
        }
        // calcular el tiempo del tween de manera que la velocidad de la carta sea constante
        var d = Math.sqrt((this.x - x) * (this.x - x) + (this.y - y) * (this.y - y));
        var tweenTime = d / Card.CARD_SPEED;
        // asociar las cartas arrastradas a la nueva pila
        for (var i = 0; i < this.attachedCards.length; i++) {
            this.attachedCards[i].pile = this.pile;
        }
        // mover con un tween hacia las coordenadas de la pila
        if (tweenTime < 50) {
            tweenTime = 50;
        }
        if (!noAudio) {
            AudioManager_1.AudioManager.getInstance().playSound("swish");
        }
        this.game.add.tween(this)
            .to({ x: x, y: y }, tweenTime, Phaser.Easing.Quadratic.Out, true)
            .onComplete.add(function () {
            this.moveAttachedCards();
            this.attachedCards.length = 0;
            this.doubleClick = false;
            BoardManager_1.BoardManager.currentInstance.cardsPositions();
            Card.tweening = false;
            if (!noAudio) {
                var rand = Math.floor(Math.random() * 3) + 1;
                AudioManager_1.AudioManager.getInstance().playSound("card_placed_0" + rand);
            }
        }, this);
    };
    Card.prototype.autoCompleteCard = function (pile) {
        var x;
        var y;
        if (GameVars_1.GameVars.draggedCard.pile) {
            var prevPile = GameVars_1.GameVars.draggedCard.pile ? { column: GameVars_1.GameVars.draggedCard.pile.column, foundation: GameVars_1.GameVars.draggedCard.pile.foundation } : null;
            var newPile = pile ? { column: pile.column, foundation: pile.foundation } : null;
            BoardManager_1.BoardManager.currentInstance.sendMoveToServer(prevPile, newPile, true);
        }
        this.pile = pile || this.pile;
        x = this.pile.x;
        y = this.pile.y;
        // calcular el tiempo del tween de manera que la velocidad de la carta sea constante
        /*let d = Math.sqrt((this.x - x) * (this.x - x) + (this.y - y) * (this.y - y));
        let tweenTime = d / Card.CARD_SPEED;*/
        // asociar las cartas arrastradas a la nueva pila
        for (var i = 0; i < this.attachedCards.length; i++) {
            this.attachedCards[i].pile = this.pile;
        }
        // mover con un tween hacia las coordenadas de la pila
        Card.tweening = true;
        this.pile.addCard(this);
        BoardManager_1.BoardManager.currentInstance.saveChange();
        AudioManager_1.AudioManager.getInstance().playSound("swish");
        this.game.add.tween(this)
            .to({ x: x, y: y }, 100, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function () {
            Card.tweening = false;
            this.doubleClick = false;
            var rand = Math.floor(Math.random() * 3) + 1;
            AudioManager_1.AudioManager.getInstance().playSound("card_placed_0" + rand);
        }, this);
    };
    Card.prototype.onDragStart = function () {
        if (GameVars_1.GameVars.paused) {
            return;
        }
        if (GameVars_1.GameVars.waitingServer) {
            return;
        }
        if (!this.turned || Card.tweening) {
            return;
        }
        BoardManager_1.BoardManager.currentInstance.startedDraggingCard(this);
        this.dragging = true;
        this.prevX = this.x;
        this.prevY = this.y;
        BoardState_1.BoardState.currentInstance.board.bringToTop(BoardState_1.BoardState.currentInstance.board.shadow);
        // colocar la carta por encima de todo
        var board = BoardState_1.BoardState.currentInstance.board;
        board.bringToTop(this);
        // y las que esta arrastre
        for (var i = 0; i < this.attachedCards.length; i++) {
            board.bringToTop(this.attachedCards[i]);
        }
        BoardManager_1.BoardManager.currentInstance.cardsPositions();
    };
    Card.prototype.finalAnimation = function (time) {
        this.onAnimation = true;
        this.game.time.events.add(time, function () {
            this.game.physics.enable(this, Phaser.Physics.ARCADE);
            this.body.gravity.setTo(0, 1000);
            var x = Math.floor(Math.random() * 100 + 50);
            var y = Math.floor(Math.random() * (-100) - 100);
            this.body.velocity.setTo(x, y);
            var rand = Math.floor(Math.random() * 3) + 1;
            AudioManager_1.AudioManager.getInstance().playSound("card_placed_0" + rand);
        }, this);
    };
    Card.prototype.rebound = function () {
        this.anchor.y = 1;
        this.y = GameConstants_1.GameConstants.GAME_HEIGHT;
        this.game.add.tween(this.scale)
            .to({ x: 1.5, y: .5 }, 150, Phaser.Easing.Linear.None, true)
            .onComplete.add(function () {
            this.visible = false;
            this.destroy();
        }, this);
        BoardState_1.BoardState.currentInstance.board.newSmoke(this.x, this.y);
    };
    Card.prototype.noMoveAnimation = function (angle) {
        AudioManager_1.AudioManager.getInstance().playSound("wrong_movement");
        this.game.add.tween(this)
            .to({ angle: -angle }, 100, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function () {
            this.game.add.tween(this)
                .to({ angle: angle / 2 }, 100, Phaser.Easing.Cubic.Out, true)
                .onComplete.add(function () {
                this.game.add.tween(this)
                    .to({ angle: 0 }, 200, Phaser.Easing.Elastic.Out, true);
            }, this);
        }, this);
    };
    Card.prototype.onDown = function (sprite, pointer) {
        if (GameVars_1.GameVars.paused) {
            return;
        }
        if (GameVars_1.GameVars.waitingServer) {
            return;
        }
        if (!Card.tweening) {
            if (!this.turned && this.dealPile) {
                BoardManager_1.BoardManager.currentInstance.nextCard();
            }
            else if (this.turned) {
                // this.anchor.set(.55);
                BoardState_1.BoardState.currentInstance.board.shadow.visible = true;
                this.downX = this.x;
                this.downY = this.y;
                this.timeLatestTap = this.game.time.now;
                this.input.enableDrag();
            }
        }
        this.pileAux = this.pile;
    };
    Card.prototype.onUp = function () {
        if (GameVars_1.GameVars.paused) {
            return;
        }
        if (GameVars_1.GameVars.waitingServer) {
            return;
        }
        if (!this.turned || !this.dragging || Card.tweening) {
            return;
        }
        if (this.turned && this.dealPile && !BoardManager_1.BoardManager.currentInstance.cardOnDealTop(this)) {
            return;
        }
        var now = this.game.time.now;
        var timeSinceLastTap = now - this.timeLatestTap;
        this.dragging = false;
        this.input.disableDrag();
        this.anchor.set(.5);
        BoardState_1.BoardState.currentInstance.board.shadow.visible = false;
        if (timeSinceLastTap < 150 && Phaser.Math.fuzzyEqual(this.x, this.downX, 2) && Phaser.Math.fuzzyEqual(this.y, this.downY, 2)) {
            GameVars_1.GameVars.draggedCard = this;
            // colocar la carta por encima de todo
            var board = BoardState_1.BoardState.currentInstance.board;
            board.bringToTop(BoardState_1.BoardState.currentInstance.board.shadow);
            board.bringToTop(this);
            // y las que esta arrastre
            for (var i = 0; i < this.attachedCards.length; i++) {
                board.bringToTop(this.attachedCards[i]);
            }
            BoardManager_1.BoardManager.currentInstance.cardsPositions();
            BoardManager_1.BoardManager.currentInstance.doubleClick();
            return;
        }
        BoardManager_1.BoardManager.currentInstance.draggedCardReleased();
        BoardManager_1.BoardManager.currentInstance.saveChange();
    };
    Card.prototype.moveAttachedCards = function () {
        for (var i = 0; i < this.attachedCards.length; i++) {
            this.attachedCards[i].x = this.x;
            this.attachedCards[i].y = this.y + (i + 1) * Pile_1.Pile.CARDS_OFFSET;
        }
        BoardState_1.BoardState.currentInstance.board.shadow.x = this.x;
        BoardState_1.BoardState.currentInstance.board.shadow.y = this.y - this.height / 2 - ((this.height / 30) * this.attachedCards.length) - 5;
        BoardState_1.BoardState.currentInstance.board.shadow.scale.y = (1 + (50 / 200) * this.attachedCards.length) * GameVars_1.GameVars.scaleY;
    };
    Card.tweening = false;
    Card.CARD_SPEED = 2;
    Card.CARD_BACK = "card-back.png";
    return Card;
}(Phaser.Sprite));
exports.Card = Card;
